import { Component } from "react";

/** Process-level error boundary. Wraps the entire app so a single render exception
 * does not show a blank white screen. Logs to console for now; production should
 * forward to a Sentry-like service.
 */
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("Vedari: caught uncaught error", error, info);
  }

  reset = () => {
    this.setState({ error: null });
    // Send the user back to the home/landing route so we get a clean re-render
    if (typeof window !== "undefined") {
      window.location.href = "/";
    }
  };

  render() {
    if (this.state.error) {
      const isHi = (typeof localStorage !== "undefined" && localStorage.getItem("vedari_lang")) === "hi";
      return (
        <div className="min-h-screen flex items-center justify-center px-6" style={{ backgroundColor: "var(--vedari-cream)", color: "var(--vedari-ink)" }}>
          <div className="max-w-md text-center">
            <p className="text-caption uppercase tracking-[0.3em]" style={{ color: "var(--vedari-gold)" }}>
              {isHi ? "एक अंधेरी खिड़की" : "A dim window"}
            </p>
            <h1 className="font-display text-4xl mt-4 leading-tight">
              {isHi ? "क्षण रुकिए।" : "A moment of pause."}
            </h1>
            <p className="font-serif italic text-body-lg mt-6 leading-relaxed" style={{ color: "var(--vedari-ink-soft)" }}>
              {isHi
                ? "कुछ अप्रत्याशित हुआ। आपकी प्रविष्टियाँ और कुंडली सुरक्षित हैं। एक बार पुनः आरंभ करें।"
                : "Something unexpected happened. Your entries and your chart are safe. Let's begin again."}
            </p>
            <button
              onClick={this.reset}
              className="mt-8 px-6 py-3 rounded-full font-medium tracking-wide transition-all active:scale-[0.98]"
              style={{ backgroundColor: "var(--vedari-gold)", color: "var(--vedari-cream)" }}
              data-testid="error-boundary-reset"
            >
              {isHi ? "आरम्भ पर लौटें" : "Return to the beginning"}
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
